// packages/domain/src/instagram.ts — shared by the web (links, handoff) and the worker (tv-isee: a DM lead's @username).
// Instagram usernames: 1-30 chars of [a-z0-9._], no leading/trailing dot, no '..'.
// Handles are case-insensitive; we store lowercase. '@' is display-only, never in the URL.
const HANDLE_RE = /^(?!\.)(?!.*\.\.)[a-z0-9._]{1,30}(?<!\.)$/;

/** Canonical username: strip a leading '@', trim, lowercase, and pull the
 *  username out of a pasted instagram.com/<user> URL. */
export function normalizeInstagramHandle(raw: string): string {
  let s = (raw ?? '').trim();
  const url = s.match(/instagram\.com\/([^/?#\s]+)/i);
  if (url?.[1]) s = url[1];
  return s.replace(/^@+/, '').trim().toLowerCase();
}

export function isValidInstagramHandle(handle: string): boolean {
  return HANDLE_RE.test(handle);
}

export function instagramUrl(handle: string): string {
  return `https://instagram.com/${handle}`;
}

/** The DM-safe username for a stored handle: normalised, or '' when it isn't a
 *  valid Instagram username (some stored values carry a leading '@'). */
export function dmHandle(raw: string | undefined): string {
  const h = normalizeInstagramHandle(raw ?? '');
  return isValidInstagramHandle(h) ? h : '';
}

/** Where a DM handoff opens: the handle's ig.me thread, or the Instagram inbox
 *  when the handle is missing or invalid. */
export function instagramDmUrl(raw: string | undefined): string {
  const h = dmHandle(raw);
  return h ? `https://ig.me/m/${h}` : 'https://www.instagram.com/direct/inbox/';
}
